import styled from '@emotion/styled';

import ValidatingFormSubmitButton from '../../../components/Button/FormSubmitButton';
import { MainContent } from '../../../components/Card/ReviewCard';
import { FormComponent } from '../../../components/Form/FormComponent';
import { TextInputField } from '../../../components/Form/FormField';
import { InternalNavLink } from '../../../components/Link/Link';
import { HEALTH_SIGNIN } from '../../../routes/routeConstants';
import Formtainer from '../../../components/Authlayout/Formtainer';
import {
  ResetPaswdDataType,
  resetPasswordInitialValues,
  ResetPaswdSchema,
} from '../../../models/auth/locum-auth/resetPassword.model';
import useUserResetPassword from '../../../hooks/auth/useUserResetPassword';

const ForgotPassword = () => {
  const { resetUserPassword, loading: resetPasswordLoading } =
    useUserResetPassword();

  const onSubmit = (value: ResetPaswdDataType) => {
    resetUserPassword({ ...value, email: value?.email?.toLowerCase() });
  };

  return (
    <>
      <Formtainer header="PASSWORD RESET">
        <MainContent>Enter your email address to reset password</MainContent>
        <Divider />
        <FormArea>
          <FormComponent
            initialValues={resetPasswordInitialValues}
            schema={ResetPaswdSchema}
            onSubmit={onSubmit}
          >
            <TextInputField
              label="Email Address"
              name="email"
              type="email"
              placeholder="Enter your email address"
              className="spanTwo"
            />
            <ValidatingFormSubmitButton className="fillParent" loading={resetPasswordLoading}>
              Reset Password
            </ValidatingFormSubmitButton>
          </FormComponent>
        </FormArea>
        <BackHome>
          <InternalNavLink className="footer1" to={HEALTH_SIGNIN}>
            Back Home
          </InternalNavLink>
        </BackHome>
      </Formtainer>
    </>
  );
};

export default ForgotPassword;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 1.5rem;
  background: linear-gradient(
    90deg,
    rgba(192, 204, 218, 0.1) 0%,
    rgba(192, 204, 218, 0.6) 36.24%,
    rgba(192, 204, 218, 0.1) 82.77%
  );
`;

const BackHome = styled.div`
  color: ${({ theme }) => theme.palette.mainBlue};
`;

const FormArea = styled.div`
  width: 100%;
`;
